@for (side of sides(); track side) {
  <div class="tw:absolute tw:from-black tw:to-transparent" [class]="sideClass[side]"></div>
}
